import * as React from 'react';
import { ValidationErrors, FormContextInnitialValues } from './FormTypes';

export const formInitialData = {
  firstName: '',
  lastName: '',
  bussinessEmail: '',
  phoneNumber: '',
  company: '',
  jobTitle: '',
  messageBox: '',
  checkbox: false,
};

export const FormContext = React.createContext<FormContextInnitialValues>({
  values: formInitialData,
  errors: {} as ValidationErrors,
  handleSubmit: () => {},
  handleChange: () => {},
  isSubmitting: false,
  submitFailureMessage: '',
});
